import React from 'react'
import { FormGroup, Label, Button, Spinner } from "reactstrap"
import Select from 'react-select'
import FormFieldError from 'components/Common/FormFieldError'


const BenchmarkForm = (props) => {
const { fields, subjectsOptions, mode } = props

const {
  handleFieldChange,
  FecthBenchmark,
  t,
  handleForm,
  handleReset,
  isSubmitting,
  isEditLoading,
} = props

  return (
    <div>
      <FormGroup>
        <Label for="subject">{t("Subjects")}</Label>
        <Select
          //styles={selectStyles}
          name="selectSubject"
          className="form-controll"
          value={fields.subject_id.value}
          options={subjectsOptions}
          onChange={option => {
            handleFieldChange("subject_id", option)
            FecthBenchmark(option.value)
          }}
        />
      </FormGroup>
      <div
        className={
          fields.subject_id.value || isEditLoading ? "" : "disabled-div"
        }
      >
        <FormGroup>
          <textarea
            name="name"
            value={fields.name.value}
            className="form-control"
            onChange={e => handleFieldChange("name", e.target.value)}
            rows="6"
            disabled={isSubmitting || !fields.subject_id.value || isEditLoading}
          />
        </FormGroup>
        <FormFieldError errors={fields.name.errors}  t={t} />
      </div>
      <div className="text-center mt-4">
        <Button
          color={mode === "create" || mode === "delete" ? "success" : "primary"}
          type="submit"
          className="mr-2 waves-effect waves-light"
          onClick={handleForm}
          disabled={isSubmitting || !fields.subject_id.value || isEditLoading}
        >
          {!isSubmitting ? (
            mode === "create" || mode === "delete" ? (
              t("Add")
            ) : (
              t("Update")
            )
          ) : (
            <>
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              {t("Sending...")}
            </>
          )}
        </Button>
        <Button
          disabled={isSubmitting || !fields.subject_id.value || isEditLoading}
          color="secondary"
          type="submit"
          className="waves-effect ms-1"
          onClick={handleReset}
        >
          {t("Cancel")}
        </Button>
      </div>
    </div>
  )
}

export default BenchmarkForm